<div class="modal-content" style="border-radius: 20px;">
  <div class="row justify-content-between ml-3 mr-3">
    <h1 class="modal-title" style="cursor:default;">{{ title }}</h1>

    <div type="button" (click)="modalRef.hide()">
      <div class="modal-close" aria-hidden="true">
        <h1 style=" font-size: 300%;">&times;</h1>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="form-group">
        <label for="city_name"><h5 class="section-label">CITY</h5></label>
        <input
          type="text"
          class="form-control form-control-lg"
          id="city_name"
          formControlName="city_name"
          maxlength="30"
        />
      </div>
      <div class="form-group ">
        <label for="state"><h5 class="section-label">STATE</h5></label>
        <select
          style="height: 40px;"
          class="form-control  form-control-lg"
          id="state"
          formControlName="state"
        >
          <option value="">Please choose a state</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District Of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </select>
      </div>
      <div class="container">
        <div class="row justify-content-between">
          <div class="thumbnail-container">
            <h5 class="section-label">
              THUMBNAIL
            </h5>
            <div class="image-container">
              <img src="{{ image }}" *ngIf="imageSelected()" />
              <div class="form-group">
                <input
                  class="file-input add"
                  type="file"
                  (change)="selectImage($event)"
                  accept=".png,.jpg"
                  *ngIf="!imageSelected()"
                />
                <input
                  class="file-input change"
                  type="file"
                  (change)="selectImage($event)"
                  accept=".png,.jpg"
                  *ngIf="imageSelected()"
                />
              </div>
              <div class="placeholder" *ngIf="!imageSelected()"></div>
            </div>
          </div>
          <div class="app-status-container">
            <div class="form-check ">
              <h5 class="section-label">
                APP STATUS
              </h5>
            </div>
            <div class="form-check">
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  id="visible"
                  formControlName="isActive"
                  value="true"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="visible"
                  >Visible</label
                >
              </div>
            </div>
            <div class="form-check">
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  id="hidden"
                  formControlName="isActive"
                  value="false"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="hidden">Hidden</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div type="submit" class="submit-city-container" (click)="validate()">
      <h5>{{ button }}</h5>
    </div>
  </div>
</div>
